/* Material */
import Divider from '@mui/material/Divider'

/* Redux */
import Redux from './FilterTree.Redux'

/* Components */
import Brands from './Brands'
import Filter from './Filter'

interface Props {
  closeOnSelect?: boolean
}

const FilterTree: React.FC<Props> = ({ closeOnSelect = true }) => {
  const { filterTree, filterBrands } = Redux()

  return <>

    {filterBrands && filterBrands.length > 0 &&
      <Brands brands={filterBrands} closeOnSelect={closeOnSelect} />
    }

    {filterTree
      .filter(f => f.options.length > 0)
      .map(filter => (
        <div key={filter.id} >
          <Filter filter={filter} closeOnSelect={closeOnSelect} />
          <Divider />
        </div>
      ))
    }

  </>

}

export default FilterTree
